 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		19: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		19: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"82f39aadb5acb5c84872fdeee5fefaa3fa225157","2":"b6fd48d8bfb594d0cb8c70d82a5fad67c1f38510","3":"e2e5e8739e8cea75b9892f5a0826160f68544b09","4":"c146261a219bac11fae749582814f3406546fc8c","5":"497543aba2517b702dac41912ad646f65db040d3","6":"0b40ef0b577516145a7f82911c173f0a97e2072c","7":"0fd30ba5ea30b34a2db4cd3d4bcefa7912e3849f","8":"95b64a6e","9":"d06c8a750ee22aa6e4eb8109383225adc8a2fbde","10":"de71a805","11":"5e2a4920","12":"3acf82fa99fa6a09aa23511c7a76ee4770acf8bb","13":"51b8e35b3312aaa709beea03ff2ae5d9f8e847a0","14":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","15":"cf7a8788f243621def3e304713316cd3e645e1c0","16":"e50e3af5140e1a5ac5b77048b4b2821ee3bb9b72","17":"ea88be26","18":"molecules-Brands","20":"0c428ae2","22":"atoms-BgLayout","23":"component---src-pages-404-js","24":"component---src-pages-content-ceos-in-zoom-js","25":"component---src-pages-content-feature-articles-js","26":"component---src-pages-content-index-js","27":"component---src-pages-content-learning-n-5-minutes-js","28":"component---src-pages-content-meet-the-team-js","29":"component---src-pages-content-more-about-n-5-js","30":"component---src-pages-content-n-5-insights-js","31":"component---src-pages-content-now-you-know-js","32":"component---src-pages-content-open-finance-js","33":"component---src-pages-content-others-js","34":"component---src-pages-content-pistacchio-ask-js","35":"component---src-pages-content-rest-api-posts-slug-js","36":"component---src-pages-digital-america-js","37":"component---src-pages-financial-access-js","38":"component---src-pages-home-contact-js","39":"component---src-pages-index-js","40":"component---src-pages-market-research-js","41":"component---src-pages-platform-js","42":"component---src-pages-privacy-policy-js","43":"component---src-pages-schedule-demo-js","44":"component---src-pages-services-js","45":"component---src-pages-work-apply-js","46":"component---src-pages-work-index-js","47":"components-organism-Methodology","48":"fb7d5399","50":"organism-ArticlesList","51":"organism-Awards-Awards","52":"organism-Chart-Chart3d","53":"organism-CustomerSay","54":"organism-DownloadableContent","55":"organism-Editors","56":"organism-FinancialIndustry-FinancialIndustry","57":"organism-HeaderAndVideo","58":"organism-HowIsIt","59":"organism-JoinUs","60":"organism-Monitor","61":"organism-N5Impact-N5Impact","62":"organism-OurOffices","63":"organism-OurTeam","64":"organism-Partners-Partners","65":"organism-SearchVideo","66":"organism-ServiceCards","67":"organism-ServiceTabs","68":"organism-Testimonies-Testimonies","69":"organism-TransformIdeas"}[chunkId]||chunkId) + "-" + {"0":"81852b6058b0ef837ba8","1":"928654f45645d569e2f4","2":"f79c2926387715668410","3":"2a7088164a6361308a09","4":"cb93ea9d57509e4d015d","5":"063b8514865227ccadac","6":"c66ad646d63f961517dc","7":"0342c28896df33f9656e","8":"144e3aa03fbfb172125c","9":"2ea976b7d3d6cffbbcd5","10":"2d60303c56e7fca3246d","11":"66d89b440f336144253b","12":"7462e97fb675a721ab35","13":"f6965f1bd800cc884974","14":"033463d9489207688c85","15":"a588d7ec51bb0e5186ab","16":"26c5bed434a5f8e9967a","17":"5e88e8f06604d1e36533","18":"4e42876e1c93eba1b98d","20":"b58dfb6dd7605adc5b4b","22":"b00d2169a420c05c9f95","23":"df4d315ae8b7d63b2ec3","24":"c4a8125f980ea8eef8ff","25":"0e6afd58641f9e9f617b","26":"24d31f0d24681417f5bb","27":"4c76e94c8650de868e2f","28":"75eb0147aafa4e0869a0","29":"d3ccd405ec301c1527b8","30":"bf8771eb7f68314dab14","31":"76180edee2288bc806b8","32":"0ef2ac51869a2f76fbd3","33":"432a38682b0d3eba048e","34":"ab243a9ed703f0e667f7","35":"4f71489cace124c05e56","36":"8326a10afda84e6f38b3","37":"0da02e5450940fcceea8","38":"b906638c687617e79338","39":"acf51915f5c6b23117c3","40":"a3c95e6cb63c28d0424d","41":"1277ac2e2cb6df4410d4","42":"711d07c59dd063994841","43":"c54fa4d49514dbe593d9","44":"c86d0e2e5e5eabb48298","45":"9875594d5aac76e0cc60","46":"ade1ed0b25adb3f49c59","47":"09ce5caef5408ea844dc","48":"7b0daea76ed918a507b3","50":"d602aa1b533b8d028c5e","51":"877ed58d7f8505396c46","52":"ff3384a803d659d3f663","53":"7f3c5bf50951656848a1","54":"1a7a70e1510f13e4820a","55":"e9b88579094aa2ddf0d0","56":"988d6ef3526610e816c6","57":"4914488c3bb9cec60ec8","58":"4ca1c7aad01854ec22b3","59":"48fc25cb02c4d4a838cd","60":"a4d19743601d22c97464","61":"c93e8116070a6d67979e","62":"fe1362099a9fa61e7c6e","63":"c579c03c74615a6adec8","64":"7101a101cf75e6740266","65":"1dd79cbcd20398b592e6","66":"7a4d96514efcfbae7d69","67":"91a05b389096acfce853","68":"c6865bce3fddbfdb88b3","69":"813852c7ec629a22ce35","71":"c79f25980cd98263d075","72":"b486a638641028b37555","73":"b8d5875bf0471a31db9b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"82f39aadb5acb5c84872fdeee5fefaa3fa225157","2":"b6fd48d8bfb594d0cb8c70d82a5fad67c1f38510","3":"e2e5e8739e8cea75b9892f5a0826160f68544b09","4":"c146261a219bac11fae749582814f3406546fc8c","5":"497543aba2517b702dac41912ad646f65db040d3","6":"0b40ef0b577516145a7f82911c173f0a97e2072c","7":"0fd30ba5ea30b34a2db4cd3d4bcefa7912e3849f","8":"95b64a6e","9":"d06c8a750ee22aa6e4eb8109383225adc8a2fbde","10":"de71a805","11":"5e2a4920","12":"3acf82fa99fa6a09aa23511c7a76ee4770acf8bb","13":"51b8e35b3312aaa709beea03ff2ae5d9f8e847a0","14":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","15":"cf7a8788f243621def3e304713316cd3e645e1c0","16":"e50e3af5140e1a5ac5b77048b4b2821ee3bb9b72","17":"ea88be26","18":"molecules-Brands","20":"0c428ae2","22":"atoms-BgLayout","23":"component---src-pages-404-js","24":"component---src-pages-content-ceos-in-zoom-js","25":"component---src-pages-content-feature-articles-js","26":"component---src-pages-content-index-js","27":"component---src-pages-content-learning-n-5-minutes-js","28":"component---src-pages-content-meet-the-team-js","29":"component---src-pages-content-more-about-n-5-js","30":"component---src-pages-content-n-5-insights-js","31":"component---src-pages-content-now-you-know-js","32":"component---src-pages-content-open-finance-js","33":"component---src-pages-content-others-js","34":"component---src-pages-content-pistacchio-ask-js","35":"component---src-pages-content-rest-api-posts-slug-js","36":"component---src-pages-digital-america-js","37":"component---src-pages-financial-access-js","38":"component---src-pages-home-contact-js","39":"component---src-pages-index-js","40":"component---src-pages-market-research-js","41":"component---src-pages-platform-js","42":"component---src-pages-privacy-policy-js","43":"component---src-pages-schedule-demo-js","44":"component---src-pages-services-js","45":"component---src-pages-work-apply-js","46":"component---src-pages-work-index-js","47":"components-organism-Methodology","48":"fb7d5399","50":"organism-ArticlesList","51":"organism-Awards-Awards","52":"organism-Chart-Chart3d","53":"organism-CustomerSay","54":"organism-DownloadableContent","55":"organism-Editors","56":"organism-FinancialIndustry-FinancialIndustry","57":"organism-HeaderAndVideo","58":"organism-HowIsIt","59":"organism-JoinUs","60":"organism-Monitor","61":"organism-N5Impact-N5Impact","62":"organism-OurOffices","63":"organism-OurTeam","64":"organism-Partners-Partners","65":"organism-SearchVideo","66":"organism-ServiceCards","67":"organism-ServiceTabs","68":"organism-Testimonies-Testimonies","69":"organism-TransformIdeas"}[chunkId]||chunkId) + "." + {"0":"1af3975ec4e045752c6e","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
